import { NavigationDto } from "@/types";

export const defaultFooterItems: NavigationDto[] = [
  {
    id: 45,
    title: "Home",
    url: "/home",
    target: "_self",
    cssClasses: "footer-link",
    iconUrl: null,
    iconCssClass: null,
    badgeText: null,
    badgeCssClass: null,
    requiresAuth: false,
    description: null,
    children: [],
  },
  {
    id: 46,
    title: "About",
    url: "/about",
    target: "_self",
    cssClasses: "footer-link",
    iconUrl: null,
    iconCssClass: null,
    badgeText: null,
    badgeCssClass: null,
    requiresAuth: false,
    description: null,
    children: [],
  },
  {
    id: 47,
    title: "Features",
    url: "/features",
    target: "_self",
    cssClasses: "footer-link",
    iconUrl: null,
    iconCssClass: null,
    badgeText: null,
    badgeCssClass: null,
    requiresAuth: false,
    description: null,
    children: [],
  },
  {
    id: 48,
    title: "Pricing",
    url: "/pricing",
    target: "_self",
    cssClasses: "footer-link",
    iconUrl: null,
    iconCssClass: null,
    badgeText: null,
    badgeCssClass: null,
    requiresAuth: false,
    description: null,
    children: [],
  },
  {
    id: 49,
    title: "Resources",
    url: "/blog",
    target: "_self",
    cssClasses: "footer-link",
    iconUrl: null,
    iconCssClass: null,
    badgeText: null,
    badgeCssClass: null,
    requiresAuth: false,
    description: null,
    children: [],
  },
  {
    id: 50,
    title: "Contact",
    url: "/contact",
    target: "_self",
    cssClasses: "footer-link",
    iconUrl: null,
    iconCssClass: null,
    badgeText: null,
    badgeCssClass: null,
    requiresAuth: false,
    description: null,
    children: [],
  },
];

export const defaultSocialLinks: NavigationDto[] = [
  {
    id: 51,
    title: "X",
    url: "#",
    target: "_blank",
    cssClasses: "social-link",
    iconUrl:
      "https://saashr-cms-media.s3.us-east-1.amazonaws.com/media/images/6707be17-6960-4ad4-944e-6976811e7b75.webp",
    iconCssClass: "icon-x",
    badgeText: null,
    badgeCssClass: null,
    requiresAuth: false,
    description: "",
    children: [],
  },
  {
    id: 52,
    title: "Facebook",
    url: "#",
    target: "_blank",
    cssClasses: "social-link",
    iconUrl:
      "https://saashr-cms-media.s3.us-east-1.amazonaws.com/media/images/f40c6490-5ea9-4283-8d03-55211d1811d8.webp",
    iconCssClass: "icon-facebook",
    badgeText: null,
    badgeCssClass: null,
    requiresAuth: false,
    description: "",
    children: [],
  },
  {
    id: 53,
    title: "Instagram",
    url: "#",
    target: "_blank",
    cssClasses: "social-link",
    iconUrl:
      "https://saashr-cms-media.s3.us-east-1.amazonaws.com/media/images/ef9db2da-7e2c-4ac4-b3f0-f14232f1b72e.webp",
    iconCssClass: "icon-instagram",
    badgeText: null,
    badgeCssClass: null,
    requiresAuth: false,
    description: "",
    children: [],
  },
  {
    id: 54,
    title: "LinkedIn",
    url: "#",
    target: "_blank",
    cssClasses: "social-link",
    iconUrl:
      "https://saashr-cms-media.s3.us-east-1.amazonaws.com/media/images/a2d25a09-5742-4041-802b-ac614b8bd4c1.webp",
    iconCssClass: "icon-linkedin",
    badgeText: null,
    badgeCssClass: null,
    requiresAuth: false,
    description: "",
    children: [],
  },
];

export const defaultLegalLinks: NavigationDto[] = [
  {
    id: 55,
    title: "Terms of Service",
    url: "/terms-of-service",
    target: "_self",
    cssClasses: "legal-link",
    iconUrl: null,
    iconCssClass: null,
    badgeText: null,
    badgeCssClass: null,
    requiresAuth: false,
    description: null,
    children: [],
  },
  {
    id: 56,
    title: "Privacy Policy",
    url: "/privacy-policy",
    target: "_blank",
    cssClasses: "legal-link",
    iconUrl: null,
    iconCssClass: null,
    badgeText: null,
    badgeCssClass: null,
    requiresAuth: false,
    description: "",
    children: [],
  },
];
